export enum THGCarCreateResultEnum {
    SUCCESS = 'success',
    REGISTRATION_LIMIT_EXCEEDED = 'registration-limit-exceeded',
}
